<script>
export default {
  methods: {
    detailValidation(p) {

      if (this.resp && this.resp.Parts != undefined) {
        let item = this.resp.Parts.find(part => part.No == this.detail.no || part.No == this.detail.No),
          response = item != undefined && item[p] != undefined ? true : false;
        return response;
      }
      return false;
    },
    fixedLength(detail, key) {
      let value = detail[key].toString().replace(/[^0-9\.\,]+/g, '');
      detail[key] = (value == '' || value == 0) ? '' : parseFloat(detail[key]).toFixed(1)
    },
    detailValidationText(p) {
      if (this.resp && this.resp.Parts != undefined) {

        let item = this.resp.Parts.find(part => part.No == this.detail.no || part.No == this.detail.No),
          response = item != undefined && item[p] != undefined ? 'Вірно: ' + item[p] : '';
        if (item && item[p] === 0) {
          if (p.includes('Edge')) {
            response = 'Вірно: Ні';
          }
          if (p.includes('rotate') || p.includes('screed_bp')) {
            response = 'Вірно: Викл(0)';
          }
        }
        return response;
      }
      return '';
    },
  },
};
</script>
